__turbopack_context__.v({
  "body": "DatePickerModal-module-scss-module__H5qH2a__body",
  "footer": "DatePickerModal-module-scss-module__H5qH2a__footer",
  "header": "DatePickerModal-module-scss-module__H5qH2a__header",
  "modalClose": "DatePickerModal-module-scss-module__H5qH2a__modalClose",
});
